import moment from "moment";
import DateFormatEnum from "../../../enums/DateFormatEnum";

const momentFormatted = moment().format(DateFormatEnum.DB_ENTRY);

export default () => ({
  loadingResponse: false,
  loadingPage: false,
  package: {},
  activeBranchId: null,
  activeViewGroupId: null,
  customerId: null,
  customerFamily: null,
  policyId: null,
  policy: null,
  viewGroups: {},
  viewGroupModels: {},
  viewOptions: {},
  views: {},
  loadingViews: false,
  initialCreateOrEditPageData: {
    coverageCodes: [],
    agencies: [],
    branches: [],
    viewGroups: [],
    mutationCodes: [],
    premiumMatrixTypes: [],
    packages: [],
    productLabels: [],
  },
  show_note_dyn1: null,
  form: {
    id: null,
    branch_id: null,
    parent_id: null,
    is_package: false,
    form_group_id: null,
    views: [],
    primary_premium: "",
    primary_coverage_code: "",
    secondary_premium: "",
    secondary_coverage_code: "",
    tertiary_premium: "",
    tertiary_coverage_code: "",
    quaternary_premium: "",
    quaternary_coverage_code: "",
    quinary_premium: "",
    quinary_coverage_code: "",
    contractNumber: "",
    corporation_id: "",
    startDate: momentFormatted,
    duration: "",
    payment_term: "",
    expirationDate: momentFormatted,
    contractExpirationDate: momentFormatted,
    mutation_code: 6, // defaults to "In aanvraag"
    mutation_reason: null,
    mutation_date: momentFormatted,
    claim_free_years: null,
    primary_premium_step: null,
    primary_premium_type: null,
    view_group_id: null,
    policy_view_id: [],
    productLabelIds: [],
    dyn1: "",
    values: {},
  },
});
